import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDashboardPP } from "../../../actions/dashboardActionsPP";
import { Link } from "react-router-dom";
import { RouteMap } from "../../common/navigation/routeMap";
import { injectIntl, intlShape } from "react-intl";
import { ClickOutside } from "../../common/ClickOutsideWrapper";
import { showPopup } from "actions/popupActions";
import { renderAsHTML } from "../../../utils";
import { markDisclaimerShown } from "actions/marketplaceActions";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { compose } from "ramda";

const DashboardWidgetsPP = ({ intl, history }) => {
  const dispatch = useDispatch();

  const dashboardData = useSelector(state => state.dashboardPP.dashboardData);
  const clientSettings = useSelector(state => state.common.clientSettings);
  const menuItems = useSelector(state => state.common.menuItems);
  const marketplace = useSelector(state => state.marketplace);
  const { shopDisclaimerNote } = clientSettings;

  const NEWSHOP_MENU_ID = "CXAShopMain_CXAShop";

  const getNewShopUrl = menuItems => {
    const initialState = {
      id: "CXAShopMain_CXAShop",
      name: "Marketplace",
      externalUrl: "",
    };

    const menuNewShop = menuItems.find(m => m.id === NEWSHOP_MENU_ID);
    return menuNewShop || initialState;
  };

  const newShopUrl = getNewShopUrl(menuItems);

  const navigateShop = link => {
    if (!!newShopUrl.externalUrl && link === "/marketplace") {
      return (window.location.href = newShopUrl.externalUrl);
    } else {
      return link === "/marketplace" ? history.push(link) : (window.location.href = link);
    }
  };

  const handleClickShop = data => {
    window.scrollTo(0, 0);
    if (!data || data.menuId !== NEWSHOP_MENU_ID) return;
    if (data.menuId === NEWSHOP_MENU_ID && marketplace.showDisclaimer) {
      dispatch(
        showPopup({
          element: renderAsHTML(
            "div",
            intl.formatMessage({ id: "config.shopDisclaimer", defaultMessage: shopDisclaimerNote })
          ),
          callback: () => {
            dispatch(markDisclaimerShown());
            navigateShop(RouteMap[data.menuId]);
          },
          showClose: true,
        })
      );
    } else {
      navigateShop(RouteMap[data.menuId]);
    }
  };

  React.useEffect(() => {
    dispatch(getDashboardPP());
  }, []);

  const translateMessage = message => {
    return intl.formatMessage({ id: message, defaultMessage: message });
  };

  const updateMenuId = (data, oldMenuId, newMenuId) => {
    if (!Array.isArray(data)) {
      return;
    }
    const itemToUpdate = data.find(item => item.menuId === oldMenuId);
    if (itemToUpdate) {
      itemToUpdate.menuId = newMenuId;
    }
  };

  updateMenuId(dashboardData, "FlexBenefitsMain_PendingClaims", "FlexBenefitsMain_TrackClaims");

  const filteredDashboardData = dashboardData
    ? dashboardData.filter(
        item => (item.menuId in RouteMap || item.url) && item.hideInWebPortal !== true
      )
    : [];

  return (
    <div className="dashboard-container">
      {dashboardData &&
        filteredDashboardData.map(data => {
          const isShopMenu = data.menuId === NEWSHOP_MENU_ID;
          const targetUrl = RouteMap[data.menuId];
          const widgetName =
            translateMessage(data.name).length > 30
              ? translateMessage(data.name).slice(0, 30) + "..."
              : translateMessage(data.name);

          return isShopMenu ? (
            <div
              type="button"
              role="button"
              tabIndex="0"
              key={data.menuId}
              className="dashboard-item"
              onClick={() => handleClickShop(data)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  handleClickShop(data);
                }
              }}
            >
              <div className="item-link">
                <div className="item-header">
                  <img src={data.imageUrl} alt="widget" className="item-image" />
                  <p className="item-name-widgets" style={{ textAlign: "left" }}>
                    {widgetName}
                  </p>
                </div>
                <div style={{ width: "100%", textAlign: "left" }}>
                  <span className="item-description">{translateMessage(data.description)}</span>
                </div>
              </div>
            </div>
          ) : (
            <div key={data.menuId} className="dashboard-item tile-border">
              <div className="item-container">
                <ClickOutside>
                  {data.url ? (
                    <a href={data.url} className="item-link">
                      <div className="item-header">
                        <img src={data.imageUrl} alt="widget" className="item-image" />
                        <p className="item-name-widgets">
                          {translateMessage(data.name).length > 30
                            ? translateMessage(data.name).slice(0, 30) + "..."
                            : translateMessage(data.name)}
                        </p>
                      </div>
                      <p className="item-description">{translateMessage(data.description)}</p>
                    </a>
                  ) : (
                    <Link to={targetUrl} className="item-link" onClick={handleClickShop}>
                      <div className="item-header">
                        <img src={data.imageUrl} alt="widget" className="item-image" />
                        <p className="item-name-widgets">
                          {translateMessage(data.name).length > 30
                            ? translateMessage(data.name).slice(0, 30) + "..."
                            : translateMessage(data.name)}
                        </p>
                      </div>
                      <p className="item-description">{translateMessage(data.description)}</p>
                    </Link>
                  )}
                </ClickOutside>
              </div>
            </div>
          );
        })}
    </div>
  );
};

DashboardWidgetsPP.propTypes = {
  intl: intlShape.isRequired,
  history: PropTypes.object,
};

export default compose(withRouter, injectIntl)(DashboardWidgetsPP);



// WEBPACK FOOTER //
// ./components/dashboard/DashboardNewUI/DashboardWidgetsPP.js